/* eslint-disable */
import {
  getDrivers,
  getDriver,
  createDriver,
  updateDriver,
  deleteDriver,
} from '@/methods/driver';
import { ElNotification } from 'element-plus';
import { getDenyPrivilegeObject, getErrorMessage } from '@/compositions/helpers/helpers';

// Дедуп одновременных запросов списка: блок ЭТРН и постоянно смонтированные
// *FormDialog дергают getDrivers в один тик — схлопываем их в один HTTP-запрос.
// Ключ — partnerId (или 'all' без фильтра): фильтрованный и полный список
// не должны схлопываться в один запрос.
const driversInFlight = new Map();
const driverDetailsInFlight = new Map();

// Список в сторе один на всё приложение, а запросы с разным фильтром летят параллельно.
// Отвечают они в произвольном порядке, поэтому применяем только ответ на последний
// запрошенный фильтр — иначе полный список затирает отфильтрованный.
let driversLatestKey = null;

const state = {
  list: [],
  dataIsUpdated: false,
};

const getters = {
  getDrivers(state) {
    return state.list;
  },
};

const mutations = {
  UPSERT_DRIVER(state, driver) {
    state.list = [...state.list.filter((item) => item.id !== driver.id), driver];
  },
  UPDATE_DRIVERS(state, data) {
    state.list = data;
  },
  DRIVERS_DATA_IS_UPDATED(state, data) {
    state.dataIsUpdated = data;
  },
};

const actions = {
  getDriver({ commit }, id) {
    if (driverDetailsInFlight.has(id)) return driverDetailsInFlight.get(id);
    const request = getDriver(id).then((response) => {
      if (!response.data.success) throw new Error('Не удалось загрузить водителя');
      commit('UPSERT_DRIVER', response.data.data);
      return response.data.data;
    }).finally(() => driverDetailsInFlight.delete(id));
    driverDetailsInFlight.set(id, request);
    return request;
  },
  // payload.partnerId — партнёр брони: список сужается до его записей и «общих».
  getDrivers({ commit }, payload = {}) {
    const partnerId = Number(payload?.partnerId) || null;
    const key = partnerId ?? 'all';

    driversLatestKey = key;

    if (driversInFlight.has(key)) return driversInFlight.get(key);

    const request = getDrivers(partnerId ? { partnerId } : {})
      .then((response) => {
        if (key !== driversLatestKey) return;

        if ('success' in response.data && response.data.success) {
          commit('UPDATE_DRIVERS', response.data.data);
          commit('privilege/UPDATE_DRIVER_PRIVILEGE', response.data.privilege, { root: true });
          commit('DRIVERS_DATA_IS_UPDATED', false);
        }
      })
      .catch(() => {
        if (key !== driversLatestKey) return;

        commit('privilege/UPDATE_DRIVER_PRIVILEGE', getDenyPrivilegeObject(), { root: true });
      })
      .finally(() => {
        driversInFlight.delete(key);
      });

    driversInFlight.set(key, request);

    return request;
  },

  createDriver({ commit }, params) {
    return createDriver(params)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('DRIVERS_DATA_IS_UPDATED', true);

          return response.data.data?.id ?? null;
        }

        return null;
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });

        return null;
      });
  },

  updateDriver({ commit }, { id, data }) {
    return updateDriver(id, data)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('DRIVERS_DATA_IS_UPDATED', true);

          return id;
        }

        return null;
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });

        return null;
      });
  },

  deleteDriver({ commit }, id) {
    deleteDriver(id)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('DRIVERS_DATA_IS_UPDATED', true);
        }
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
